import { render, staticRenderFns } from "./MessageFromTeacher.vue?vue&type=template&id=33dc9a44&scoped=true&"
import script from "./MessageFromTeacher.vue?vue&type=script&lang=js&"
export * from "./MessageFromTeacher.vue?vue&type=script&lang=js&"
import style0 from "./MessageFromTeacher.vue?vue&type=style&index=0&id=33dc9a44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dc9a44",
  null
  
)

export default component.exports